import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { formatDateS } from '../../helpers/helper';
import { BannerAction, BannerEditor, LabelValue } from '../../interfaces/interfaces';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-bannereditor',
  templateUrl: './bannereditor.component.html',
  styleUrls: ['./bannereditor.component.scss']
})
export class BannereditorComponent extends UnsubscribeComponent implements OnDestroy, AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  bannerAction = BannerAction;
  bannerId: number = null;
  bannerEditor: BannerEditor = null;
  dataLoading = false;
  loading = false;
  bannerEditorFormGroup: FormGroup = null;

  bannerActions: LabelValue[] = [
    { label: 'Nincs', value: BannerAction.NOCLICK },
    { label: 'Adott linkre mutat', value: BannerAction.URL }
  ];

  file: File = null;

  domain: string = null;

  constructor(
    private apiService: ApiService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private dataService: DataService
  ) {
    super();
    this.bannerId = this.config.data.bannerId;
    this.domain = this.dataService.domain;
    this.init();
  }

  init(): void {
    this.initBannerEditorFormGroup();
    this.loadData();
  }

  loadData(): void {
    this.dataLoading = true;
    if (this.bannerId !== null) {
      this.apiService.getBanner(this.bannerId).pipe(takeUntil(this.unsubscribe)).subscribe(({ bannerEditor }) => {
        this.bannerEditor = bannerEditor;
        this.bannerEditor.date = formatDateS(this.bannerEditor.date);
        this.fillBannerEditorForm(this.bannerEditor);
      }).add(() => {
        this.dataLoading = false;
      });
    }
  }

  initBannerEditorFormGroup(): void {
    this.bannerEditorFormGroup = new FormGroup({
      name: new FormControl('', [Validators.required]),
      action: new FormControl(BannerAction.NOCLICK, [Validators.required]),
      actionValue: new FormControl(''),
      date: new FormControl(null, [Validators.required]),
      active: new FormControl(false, [Validators.required])
    });
  }

  fillBannerEditorForm(bannerEditor: BannerEditor): void {
    this.bannerEditorFormGroup.patchValue(bannerEditor);
  }

  save(): void {
    if (this.bannerEditorFormGroup.invalid) {
      return;
    }
    this.loading = true;
    const bannerEditor: any = this.bannerEditorFormGroup.value;
    if (this.bannerId === null) {
      this.apiService.createBanner(bannerEditor, this.file).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.ref.close(true);
      }).add(() => {
        this.loading = false;
      });
    } else {
      this.apiService.updateBanner(this.bannerId, bannerEditor, this.file).pipe(
        takeUntil(this.unsubscribe)
      ).subscribe(() => {
        this.ref.close(true);
      }).add(() => {
        this.loading = false;
      });
    }
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  fileUploadInputChanged(files: FileList): void {
    if (files.length > 0) {
      this.file = files.item(0);
    }
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }
}
